module.exports = __webpack_public_path__ + "static/logo-5181bec82f6bdaffb5bbd9c0c9023ade.svg";